/**
 * Wrapper pour ExerciceForm qui surveille les changements
 * (extrait de ExerciceAdvancedEditor, déplacement pur).
 */
import React from 'react';
import { Exercice } from '../../../types';
import ExerciceForm from '../ExerciceForm';

interface ExerciceFormWrapperProps {
  exercice: Exercice;
  returnPath: string;
  saving?: boolean;
  readOnly?: boolean;
  onSubmit: (data: Omit<Exercice, 'id'>) => void;
  onCancel: () => void;
  onChange: (data: Omit<Exercice, 'id'>) => void;
  onFieldBlur?: (field: string, value: unknown, allFormData: Omit<Exercice, 'id'>) => void;
}

/** Wrapper pour ExerciceForm qui surveille les changements. */
const ExerciceFormWrapper: React.FC<ExerciceFormWrapperProps> = ({
  exercice,
  returnPath,
  saving,
  readOnly,
  onSubmit,
  onCancel,
  onChange,
  onFieldBlur,
}) => {
  return (
    <ExerciceForm
      exercice={exercice}
      returnPath={returnPath}
      saving={saving}
      readOnly={readOnly}
      onSubmit={onSubmit}
      onCancel={onCancel}
      onChange={onChange}
      onFieldBlur={onFieldBlur}
    />
  );
};

export default ExerciceFormWrapper;
